import FakeTimers from '@sinonjs/fake-timers';

if (window.FAKE_TIME) {
  FakeTimers.install({
    now: new Date(window.FAKE_TIME),
    shouldAdvanceTime: true
  });
}
